import { render, staticRenderFns } from "./GroupInvoice.vue?vue&type=template&id=11bfb3ba&scoped=true"
import script from "./GroupInvoice.vue?vue&type=script&lang=js"
export * from "./GroupInvoice.vue?vue&type=script&lang=js"
import style0 from "./GroupInvoice.vue?vue&type=style&index=0&id=11bfb3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bfb3ba",
  null
  
)

export default component.exports